import { Autocomplete, TextField } from "@mui/material";
import { useMemo } from "react";
import type { ValidationResult } from "@entrilia/shared/utilities/validators";
import type { CompanyInfo, OrganizationInfo } from "../../api/clientsManagementTypes";
import { removeClientsOfRealOrgsFromInternalOrgs } from "./companySelectorHelpers";

interface Props {
  organizations: OrganizationInfo[];
  value: CompanyWithOrganization | null;
  onChange: (organization: CompanyWithOrganization | null) => void;
  validationResult?: ValidationResult;
}

export interface CompanyWithOrganization extends CompanyInfo {
  orgName: string;
}

const CompanySelector = ({ organizations, value, onChange, validationResult }: Props) => {
  const companies = useMemo<CompanyWithOrganization[]>(
    () =>
      removeClientsOfRealOrgsFromInternalOrgs(organizations).flatMap((org) =>
        org.managesClients.map((company) => ({
          ...company,
          orgName: org.name,
        }))
      ),
    [organizations]
  );

  return (
    <Autocomplete
      fullWidth
      options={companies}
      groupBy={(c) => c.orgName}
      value={value}
      onChange={(_, value) => onChange(value)}
      getOptionLabel={(option) => `${option.name} - ${option.clientCode}`}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Company"
          error={validationResult?.isValid === false}
          helperText={validationResult?.error}
        />
      )}
    />
  );
};

export default CompanySelector;
